import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
const forWho = ['Tienes más de 40 años y notas grasa abdominal inexplicable', 'Te sientes cansada crónicamente, especialmente a media tarde', 'Sufres de insomnio o despertares nocturnos a las 3:00 AM', 'Buscas un método natural basado en ciencia hormonal real', 'Quieres resultados sin dietas extremas ni cardio agotador'];
const notForWho = ['Buscas pastillas milagrosas sin cambiar ningún hábito', 'Prefieres seguir dietas de hambre a pesar de no ver resultados', 'No estás dispuesta a dedicar 10 minutos al día a tu bienestar'];
export function ForWhom() {
  return <section className="py-20 lg:py-32 bg-[#FDFAF6]" data-id="element-73">
      <div className="container mx-auto px-6 lg:px-12" data-id="element-74">
        <div className="grid lg:grid-cols-2 gap-8 max-w-6xl mx-auto" data-id="element-75">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="bg-[#A8D5AC]/20 border-2 border-[#2D5A34] rounded-2xl p-8" data-id="element-76">
            <h2 className="text-2xl lg:text-3xl font-bold text-[#2D5A34] mb-6" data-id="element-77">
              ✅ Este protocolo es para ti si...
            </h2>
            <ul className="space-y-4" data-id="element-78">
              {forWho.map((item, i) => <motion.li key={i} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6,
              delay: i * 0.1
            }} className="flex items-start gap-3" data-id="element-79">
                  <CheckIcon className="w-5 h-5 text-[#2D5A34] flex-shrink-0 mt-1" data-id="element-80" />
                  <span className="text-[#2D2D2D]" data-id="element-81">{item}</span>
                </motion.li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="bg-[#C2856A]/20 border-2 border-[#C2856A] rounded-2xl p-8" data-id="element-82">
            <h2 className="text-2xl lg:text-3xl font-bold text-[#C2856A] mb-6" data-id="element-83">
              ❌ Este protocolo NO es para ti si...
            </h2>
            <ul className="space-y-4" data-id="element-84">
              {notForWho.map((item, i) => <motion.li key={i} initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6,
              delay: i * 0.1
            }} className="flex items-start gap-3" data-id="element-85">
                  <XIcon className="w-5 h-5 text-[#C2856A] flex-shrink-0 mt-1" data-id="element-86" />
                  <span className="text-[#2D2D2D]" data-id="element-87">{item}</span>
                </motion.li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}